var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverviewProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.46 17.53c-.38-.51-.88-.91-1.46-1.16-1.31-.59-2.67-1.07-4.07-1.41-2.58-.64-5.28-.64-7.86 0-1.41.35-2.78.82-4.11 1.41-.57.26-1.06.66-1.43 1.16a2.8 2.8 0 0 0-.54 1.7v2.07H22v-2.07a2.8 2.8 0 0 0-.54-1.7Zm-.57 2.66H3.11v-.97c0-.38.13-.75.36-1.05.26-.36.6-.65 1-.84 1.19-.59 2.45-1.04 3.75-1.34 1.24-.27 2.51-.41 3.79-.41 1.27 0 2.53.14 3.77.41 1.3.3 2.57.75 3.77 1.34.4.19.74.48 1 .84.22.31.35.67.36 1.05v.96ZM12 2.7h-.28a3.976 3.976 0 0 0-3.83 4.11c-.03 1.11.39 2.18 1.16 2.96.77.79 1.84 1.21 2.95 1.18 1.1.03 2.17-.39 2.95-1.18.78-.79 1.19-1.86 1.16-2.96v-.28A3.976 3.976 0 0 0 12 2.7Zm2.16 6.29c-.57.57-1.35.88-2.16.86-.81.02-1.59-.29-2.16-.86-.58-.56-.9-1.34-.88-2.14-.02-.81.3-1.59.88-2.16.57-.56 1.33-.87 2.13-.88 1.69 0 3.06 1.35 3.07 3.04.02.81-.3 1.58-.88 2.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewProfile);
export default __webpack_public_path__ + "static/media/Overview - Profile.941d4d9bc1aac9ec4f953c6d23f48b5c.svg";
export { ForwardRef as ReactComponent };